import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
import { adminapi } from '../../ApiNames';


export const fetchDataSuccess = (data: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});

export const fetchPieChartDataSuccess = (pieChartData: any,piechartOptions: any) => ({
    type: 'FETCH_PIE_CHART_DATA_SUCCESS',
    payload: {pieChartData,piechartOptions}
});

export const fetchDonorChartDataSuccess = (donorChartData: any,donorrchartOptions:any) => ({
    type: 'FETCH_Donor_CHART_DATA_SUCCESS',
    payload: {donorChartData,donorrchartOptions}
});
//To get list of officers data
export const fetchData = (userid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { userid:userid };
            const apiname = adminapi.addashboard;
            const response = await LoginService.getData(apiname, payload);
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
//To get pie chart data
// export const fetchPieChartData = () => {
//     return async (dispatch: Dispatch) => {
//             try {
//                 const payload = { q: 1 };
//                 const apiname = adminapi.adcharts;
//                 // const response = await LoginService.getData(apiname,payload)
//                 const response = await LoginService.getData(apiname, payload);

//                 if (Array.isArray(response) && response.length > 0) {
//                     const documentStyle = getComputedStyle(document.documentElement);
//                     const labels = response.map(item => item.label); 
//                     const values = response.map(item => item.value);
//                     const data = {
//                         // labels: ['A', 'B', 'C'],
//                         labels: labels,
//                         datasets: [
//                             {
//                                // data: response
//                                data: values
//                             }
//                         ]
//                     }
//                     const options = {
//                         plugins: {
//                             legend: {
//                                 labels: {
//                                     usePointStyle: true
//                                 }
//                             }
//                         }
//                     };
//                     dispatch(fetchPieChartDataSuccess(data, options));
//                 }
//             } catch (error) {
//                 console.error('Error fetching chart data:', error);
//             }
//     };
// };

// Redux Action
export const fetchPieChartData = () => {

    return async (dispatch: Dispatch) => {

        try {

            const payload = { q: 1 };

            const apiname = adminapi.adcharts;

            const response = await LoginService.getData(
                apiname,
                payload
            );

            if (
                Array.isArray(response) &&
                response.length > 0
            ) {

                const documentStyle =
                    getComputedStyle(document.documentElement);

                const labels = response.map(
                    (item) => item.label
                );

                const values = response.map(
                    (item) => item.value
                );

                const data = {

                    labels,

                    datasets: [
                        {
                            label: 'Donations',

                            data: values,

                            backgroundColor: [
                                '#3B82F6',
                                '#10B981',
                                '#F59E0B',
                                '#EF4444',
                                '#8B5CF6',
                                '#06B6D4',
                                '#EC4899'
                            ],

                            hoverBackgroundColor: [
                                '#2563EB',
                                '#059669',
                                '#D97706',
                                '#DC2626',
                                '#7C3AED',
                                '#0891B2',
                                '#DB2777'
                            ],

                            borderColor: '#ffffff',

                            borderWidth: 3,

                            hoverOffset: 15
                        }
                    ]
                };

                const options = {

                    maintainAspectRatio: false,

                    cutout: '60%',

                    plugins: {

                        legend: {

                            position: 'bottom',

                            labels: {

                                usePointStyle: true,

                                padding: 20,

                                font: {
                                    size: 14,
                                    weight: '600'
                                },

                                color:
                                    documentStyle.getPropertyValue(
                                        '--text-color'
                                    )
                            }
                        },

                        tooltip: {

                            backgroundColor: '#1f2937',

                            titleColor: '#ffffff',

                            bodyColor: '#ffffff',

                            padding: 12,

                            cornerRadius: 10,

                            callbacks: {

                                label: function (context: any) {

                                    const label =
                                        context.label || '';

                                    const value =
                                        context.raw || 0;

                                    const total =
                                        context.dataset.data.reduce(
                                            (
                                                a: number,
                                                b: number
                                            ) => a + b,
                                            0
                                        );

                                    const percentage = (
                                        (value / total) *
                                        100
                                    ).toFixed(1);

                                    return `${label}: ${value} (${percentage}%)`;
                                }
                            }
                        }
                    },

                    animation: {

                        animateRotate: true,

                        animateScale: true
                    }
                };

                dispatch(
                    fetchPieChartDataSuccess(
                        data,
                        options
                    )
                );
            }

        } catch (error) {

            console.error(
                'Error fetching chart data:',
                error
            );
        }
    };
};
//To get bar chart data
// export const fetchDonorChartData = () => {
//     return async (dispatch: Dispatch) => {
//         try {
//             const payload = { q: 2 };
//             const apiname = adminapi.adcharts;
//             const response = await LoginService.getData(apiname, payload);
//             if (Array.isArray(response) && response.length > 0) {
//               const labels = response.map(item => item.label); 
//               const values = response.map(item => item.value);
//               const data = {
//                 labels: labels,
//                 datasets: [
//                   {
//                     label:'Members',
//                     data: 
//                       values
//                     ,
//                     backgroundColor: [
//                       'rgba(255, 159, 64, 0.2)',
//                       'rgba(75, 192, 192, 0.2)',
//                       'rgba(54, 162, 235, 0.2)',
//                       'rgba(153, 102, 255, 0.2)',
//                     ],
//                     borderColor: [
//                       'rgb(255, 159, 64)',
//                       'rgb(75, 192, 192)',
//                       'rgb(54, 162, 235)',
//                       'rgb(153, 102, 255)',
//                     ],
//                     borderWidth: 1,
//                   },
//                 ],
//               };
//               const options = {
//                 scales: {
//                   y: {
//                     beginAtZero: true,
//                   },
//                 },
//               };
//               dispatch(fetchDonorChartDataSuccess(data, options));
//             }
//           } catch (error) {
//             console.error('Error fetching chart data:', error);
//           }

//     };
// };


// Redux Action
export const fetchDonorChartData = () => {

    return async (dispatch: Dispatch) => {

        try {

            const payload = { q: 2 };

            const apiname = adminapi.adcharts;

            const response = await LoginService.getData(
                apiname,
                payload
            );

            if (
                Array.isArray(response) &&
                response.length > 0
            ) {

                const documentStyle =
                    getComputedStyle(document.documentElement);

                const labels = response.map(
                    (item) => item.label
                );

                const values = response.map(
                    (item) => item.value
                );

                const data = {

                    labels,

                    datasets: [
                        {
                            label: 'Applications',

                            data: values,

                            borderRadius: 12,

                            borderSkipped: false,

                            backgroundColor: [
                                '#3B82F6',
                                '#10B981',
                                '#F59E0B',
                                '#EF4444',
                                '#8B5CF6',
                                '#06B6D4'
                            ],

                            hoverBackgroundColor: [
                                '#2563EB',
                                '#059669',
                                '#D97706',
                                '#DC2626',
                                '#7C3AED',
                                '#0891B2'
                            ],

                            maxBarThickness: 60
                        }
                    ]
                };

                const options = {

                    maintainAspectRatio: false,

                    responsive: true,

                    plugins: {

                        legend: {

                            display: true,

                            position: 'top',

                            labels: {

                                color:
                                    documentStyle.getPropertyValue(
                                        '--text-color'
                                    ),

                                font: {
                                    size: 14,
                                    weight: '600'
                                }
                            }
                        },

                        tooltip: {

                            backgroundColor: '#111827',

                            titleColor: '#ffffff',

                            bodyColor: '#ffffff',

                            padding: 12,

                            cornerRadius: 10
                        }
                    },

                    scales: {

                        x: {

                            grid: {
                                display: false
                            },

                            ticks: {

                                color:
                                    documentStyle.getPropertyValue(
                                        '--text-color-secondary'
                                    ),

                                font: {
                                    size: 13
                                }
                            }
                        },

                        y: {

                            beginAtZero: true,

                            grid: {

                                color: '#e5e7eb',

                                drawBorder: false
                            },

                            ticks: {

                                color:
                                    documentStyle.getPropertyValue(
                                        '--text-color-secondary'
                                    ),

                                font: {
                                    size: 12
                                }
                            }
                        }
                    },

                    animation: {

                        duration: 1500,

                        easing: 'easeOutQuart'
                    }
                };

                dispatch(
                    fetchDonorChartDataSuccess(
                        data,
                        options
                    )
                );
            }

        } catch (error) {

            console.error(
                'Error fetching chart data:',
                error
            );
        }
    };
};

